import React, { useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { Responsive, WidthProvider } from 'react-grid-layout';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import { useParams } from 'react-router';
import _ from 'lodash';
import { useDispatch } from 'react-redux';
import { ContextMenu } from 'primereact/contextmenu';
import { Toast } from 'primereact';
import { Menu } from 'primereact/menu';
import { Tooltip } from 'primereact/tooltip';
import { Skeleton } from 'primereact/skeleton';
import { FileClock } from 'lucide-react';
import { ConfirmDialog } from 'primereact/confirmdialog';

import {
  getFilterDetails,
  getDataSource,
} from '../Widget/service/widget.service';
import { checkPermission } from '../../../utils/Helpers';
import permissions from '../../../config/permissions';
import {
  setChartClickResponse,
  setPageHeaderComponent,
} from '../../../redux/slices/page-header.slice';
import { RandomCard } from '../Dashboard/components/RandomCards';
import PageHeaderBreadcrumb from '../../shared/PageHeader/PageHeaderBreadcrumb';
import { useConfirmDialogContext } from '../../../contexts/ConfirmDialog';

import DashboardWidgetRenderer from './WidgetRenderer/DashboardWidgetRenderer';
import {
  getDashboardDetails,
  updateWidgets,
  deleteWidget,
  getDashboardFilterConfig,
  updateDashboardFilterConfig,
} from './services/Dashboards.service';
import AddWidgetsToDashboard from './components/AddWidgetsToDashboard';
import DashboardFilters from './DashboardFilters';
import { SOURCE } from './constants/constants';
import {
  clearStoredDashboardAppliedFilters,
  getStoredDashboardAppliedFilters,
  mapCubesToGroupedFilterOptions,
  mapDashboardFilterValuesToCubeFilters,
  normalizeSavedFilterConfig,
  setStoredDashboardAppliedFilters,
} from './helpers/dashboard-filters.helper';

const ResponsiveGridLayout = WidthProvider(Responsive);

const AddViewEditDashboard = ({
  type,
  dashboardId,

  setWidgetFilterQuery,
  applyFilters,
  setApplyFilters,
  clearFilters,
  setClearFilters,
  homeFilters,
  region,
  storeNumber,
  district,
  category,
  source,
  projectType,
  installers,
  homeFilterDateDimension,
  status,
  workroom,
  scheduleDate,
  completionDate,
  checkDate,
  refreshDashboardList,
  dateSold,
}) => {
  const { id } = useParams();
  const targetDashboardId = type === 'home' ? dashboardId : id;
  const toast = React.useRef(null);
  const { showConfirmationDialog } = useConfirmDialogContext();
  const action = window.location.pathname.split('/')[3];
  const history = useHistory();
  const dispatch = useDispatch();
  const toastTopCenter = useRef(null);
  const [dialogOpen, setDialogOpen] = React.useState(false);
  // Widgets query and data variables
  const [widgetQuery, setWidgetQuery] = React.useState([]);
  // Dashboard variable
  const [dashboardData, setDashboardData] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const [layout, setLayout] = React.useState([]);

  const [deleteWidgetId, setDeleteWidgetId] = React.useState(null);
  const [deleteWidgetIds, setDeleteWidgetIds] = React.useState([]);
  const configureDialogOpen = false;
  const [getRemoveWidgetId, setRemoveWidgetId] = React.useState(null);

  const [getDashboardName, setDashboardName] = React.useState(null);
  const [, setGridCols] = React.useState(12);

  const [filterDetails, setFilterDetails] = React.useState(null);
  const [filterGroupedOptions, setFilterGroupedOptions] = React.useState([]);
  const [appliedFilterDimensions, setAppliedFilterDimensions] = React.useState(
    []
  );
  const [dashboardFilterValues, setDashboardFilterValues] = React.useState(
    () =>
      getStoredDashboardAppliedFilters(
        type === SOURCE.HOME ? targetDashboardId : null
      ).filterValues
  );
  const [dashboardCubeFilters, setDashboardCubeFilters] = React.useState(
    () =>
      getStoredDashboardAppliedFilters(
        type === SOURCE.HOME ? targetDashboardId : null
      ).cubeFilters
  );
  const [filterOptionsLoading, setFilterOptionsLoading] = React.useState(false);
  const [filterConfigSubmitLoading, setFilterConfigSubmitLoading] =
    React.useState(false);
  const [isDragging, setIsDragging] = React.useState(false);
  // View Dashboard Filter States
  const [viewDashboardClearFilters, setViewDashboardClearFilters] =
    React.useState(false);

  const [clickedWidgetId, setClickedWidgetId] = React.useState(0);
  const [routingWidget, setRoutingWidget] = React.useState(0);
  const [modifyTemplateId, setModifyTemplateId] = React.useState();

  const addWidgetBreadcrumb = [
    {
      label: 'Reports & Logs',
      icon: FileClock,
    },
    {
      label: 'Reports',
    },
    {
      label: 'Dashboards',
      url: action ? '/admin/dashboards' : '/dashboard',
    },
  ];

  if (getDashboardName?.dashboard_id) {
    addWidgetBreadcrumb.push({
      label: getDashboardName?.name,
      url: `/admin/dashboard/edit/${getDashboardName?.dashboard_id}`,
    });
  }

  const contextmenuRef = useRef(null);

  const [clickedWidgetButtonURL, setClickedWidgetButtonURL] =
    React.useState(null);

  // Widget Menu Click event
  const handleClick = (event, widgetQuery, index) => {
    setDeleteWidgetId(widgetQuery?.widget_id);
    setModifyTemplateId({
      widget_template_id: widgetQuery?.widget_template_id,
      dashboard_id: widgetQuery?.dashboard_id,
    });
    if (widgetQuery?.widget_id) {
      setDeleteWidgetIds([...deleteWidgetIds, widgetQuery?.widget_id]);
    }

    setRemoveWidgetId(index);
  };
  const accept = async () => {
    if (deleteWidgetId && deleteWidgetId !== undefined) {
      const deleteWIdget = await deleteWidget(
        deleteWidgetId,
        toast,
        id,
        setLoading,
        setDashboardData,
        () => {},
        setWidgetQuery
      );
      if (deleteWIdget && typeof refreshDashboardList === 'function') {
        refreshDashboardList();
      }
    } else {
      if (widgetQuery.length === 1) {
        setWidgetQuery(null);
      } else {
        widgetQuery.splice(getRemoveWidgetId, 1);
        setWidgetQuery(widgetQuery);
      }
    }
  };
  const handleDelete = () => {
    showConfirmationDialog({
      message: updatedLayout?.length
        ? type == 'home'
          ? 'This would delete the widget from this dashboard, would you like to continue ?'
          : 'Current layout changes would be discarded. Are you sure you still want to delete the Widget?'
        : 'Are you sure you still want to delete the Widget?',
      header: 'Delete Widget',
      icon: 'pi pi-exclamation-triangle',
      acceptClassName: 'p-button-primary p-button-sm',
      rejectClassName: 'p-button-outlined p-button-sm',
      accept,
      reject: () => false,
    });
  };

  // To create initial Dashboard Layout
  const generateLayout = () => {
    return _.map(widgetQuery, function (item, i) {
      let maxY = layout?.length
        ? Math.max(...layout.map(val => val?.y + val?.h))
        : Math.max(
            ...widgetQuery.map(val => val?.y_axis_position + val?.height)
          ) || Math.floor((i * 2) / 6) * 2;

      let maxX = layout?.length
        ? Math.max(...layout.map(val => val?.x + val?.w))
        : Math.max(
            ...widgetQuery.map(val => val?.x_axis_position + val?.width)
          ) || (i * 4) % 6;
      const isGaugeChart = item?.chart_type === 'gauge';
      const isTabularReport = item?.chart_type === 'tabular-report';
      const isPieChart = item?.chart_type === 'pie-chart';
      const isTableReport = item?.chart_type === 'table-report';
      const isButtonReport =
        item?.widget_template?.widget_display_type?.[0] ===
        'external-link-button';
      const isCardReport = item?.chart_type === 'card';
      const isProgressBar = item?.chart_type === 'progress-bar';
      return {
        widget_id: item?.widget_id,
        x:
          item?.x_axis_position !== null
            ? item?.x_axis_position
            : layout[i]?.x || maxX,
        y:
          item?.y_axis_position !== null
            ? item?.y_axis_position
            : layout[i]?.y || maxY,
        w: item?.width
          ? item?.width
          : isButtonReport || isTabularReport
            ? 1
            : isGaugeChart
              ? 2.2
              : isTableReport
                ? 10
                : 2.2,
        h: item?.height
          ? item?.height
          : isButtonReport || isTabularReport || isCardReport
            ? 1
            : isGaugeChart
              ? 6
              : isPieChart
                ? 6
                : isTableReport
                  ? 15
                  : isProgressBar
                    ? 5
                    : 6,
        i: item?.index?.toString(),
        static: action == 'view' || type == 'home' ? true : false,
        minW: isGaugeChart
          ? 2.2
          : isTableReport
            ? 10
            : isCardReport
              ? 1
              : isButtonReport
                ? 1
                : 2,
        minH: isGaugeChart
          ? 6
          : isPieChart
            ? 6
            : isTableReport
              ? 15
              : isButtonReport || isCardReport
                ? 1
                : isProgressBar
                  ? 5
                  : 6,
        maxW: Infinity,
        maxH: (isButtonReport && 2) || Infinity,
        isResizable:
          action == 'view' || type == 'home' || isTabularReport ? false : true,
      };
    });
  };

  // Fetch dashboard details by its id
  React.useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const filterResponse = await getFilterDetails();
        setFilterDetails(filterResponse);

        if (action !== 'create' && type !== 'home') {
          await getDashboardDetails(
            id,
            setLoading,
            setDashboardData,
            () => {},
            setWidgetQuery,
            () => {},
            setApplyFilters,
            setDashboardName
          );
        }

        if (type === 'home') {
          await getDashboardDetails(
            dashboardId,
            setLoading,
            setDashboardData,
            () => {},
            setWidgetQuery,
            setWidgetFilterQuery,
            setApplyFilters,
            setDashboardName
          );
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [action]);

  React.useEffect(() => {
    let isCancelled = false;

    const fetchFilterOptions = async () => {
      setFilterOptionsLoading(true);
      try {
        const cubes = await getDataSource();
        if (!isCancelled) {
          setFilterGroupedOptions(mapCubesToGroupedFilterOptions(cubes));
        }
      } catch (error) {
        if (!isCancelled) {
          setFilterGroupedOptions([]);
        }
        console.log(error);
      } finally {
        if (!isCancelled) {
          setFilterOptionsLoading(false);
        }
      }
    };

    fetchFilterOptions();

    return () => {
      isCancelled = true;
    };
  }, []);

  React.useEffect(() => {
    let isCancelled = false;

    const fetchSavedFilterConfig = async () => {
      if (!targetDashboardId) {
        setAppliedFilterDimensions([]);
        return;
      }

      const result = await getDashboardFilterConfig(targetDashboardId);
      if (isCancelled || result?.error) {
        return;
      }

      const filters = normalizeSavedFilterConfig(result.data);
      setAppliedFilterDimensions(filters);
    };

    fetchSavedFilterConfig();

    return () => {
      isCancelled = true;
    };
  }, [targetDashboardId]);

  const handleFilterConfigSubmit = async (
    submittedDimensions = appliedFilterDimensions
  ) => {
    if (!targetDashboardId) {
      return false;
    }

    setFilterConfigSubmitLoading(true);
    try {
      const filters = Array.isArray(submittedDimensions)
        ? submittedDimensions
        : appliedFilterDimensions;
      const result = await updateDashboardFilterConfig(targetDashboardId, {
        filters,
      });

      if (result?.error) {
        toast.current?.show({
          severity: 'error',
          summary: 'Error',
          detail: result.message,
          life: 3000,
        });
        return false;
      }

      setAppliedFilterDimensions(filters);
      if (!filters.length) {
        setDashboardFilterValues({});
        setDashboardCubeFilters([]);
        if (type === SOURCE.HOME) {
          clearStoredDashboardAppliedFilters(targetDashboardId);
        }
      }
      toast.current?.show({
        severity: 'success',
        summary: 'Success',
        detail: result.message || 'Filter configuration saved successfully',
        life: 1500,
      });
      return true;
    } finally {
      setFilterConfigSubmitLoading(false);
    }
  };

  const handleDashboardFiltersApply = () => {
    const cubeFilters = mapDashboardFilterValuesToCubeFilters(
      appliedFilterDimensions,
      dashboardFilterValues
    );
    setDashboardCubeFilters(cubeFilters);
    if (type === SOURCE.HOME) {
      setStoredDashboardAppliedFilters(targetDashboardId, {
        filterValues: dashboardFilterValues,
        cubeFilters,
      });
    }
  };

  const handleDashboardFiltersClear = () => {
    setDashboardFilterValues({});
    setDashboardCubeFilters([]);
    if (type === SOURCE.HOME) {
      clearStoredDashboardAppliedFilters(targetDashboardId);
    }
  };

  // Fetch dashboard when filters are cleared
  React.useEffect(() => {
    if (clearFilters) {
      getDashboardDetails(
        dashboardId,
        setLoading,
        setDashboardData,
        () => {},
        setWidgetQuery,
        setWidgetFilterQuery,
        setApplyFilters,
        setDashboardName
      );
      setClearFilters(false);
    }
  }, [clearFilters]);

  // Fetch dashboard when filters are cleared (View Dashboard)
  React.useEffect(() => {
    if (viewDashboardClearFilters) {
      getDashboardDetails(
        id,
        setLoading,
        setDashboardData,
        () => {},
        setWidgetQuery,
        setWidgetFilterQuery,
        () => {},
        setDashboardName
      );
      setViewDashboardClearFilters(false);
    }
  }, [viewDashboardClearFilters]);

  // Update Dashboard Layout as per its widgets count
  React.useEffect(() => {
    if ((widgetQuery?.length && !layout.length) || !configureDialogOpen) {
      setLayout(generateLayout());
      setUpdatedLayout(generateLayout());
    }
  }, [widgetQuery, configureDialogOpen]);

  // Handler to update Dashboard Layout
  const [updatedLayout, setUpdatedLayout] = React.useState([]);
  const [isWidgetPositionChanged, setIsWidgetPositionChanged] =
    React.useState(false);
  const onLayoutChange = layout => {
    const updateLayout = [];

    layout.map(lay => {
      widgetQuery.map(widget => {
        if (widget?.index?.toString() === lay.i) {
          updateLayout.push(lay);
        }
      });
    });
    setUpdatedLayout(updateLayout);
  };
  // We're using the cols coming back from this to calculate where to add new items.
  const onBreakpointChange = (breakpoint, cols) => {
    setGridCols(cols);
  };
  const handleSave = () => {
    const updatedWidget = [];

    updatedLayout.map(lay => {
      widgetQuery.map(widget => {
        if (widget?.index?.toString() === lay.i) {
          updatedWidget.push(widget);
        }
      });
    });

    updateWidgets(
      true,
      updatedLayout,
      updatedWidget,
      history,
      setLoading,
      setDashboardData,
      () => {},
      setWidgetQuery,
      setUpdatedLayout
    );
  };

  // Handler to open a dialog to add new widget
  const handleAddNewWidget = () => {
    setDialogOpen(true);
  };
  const dashboardDetails = {
    dashboard_id: getDashboardName?.dashboard_id,
    dashboard_name: getDashboardName?.name,
    dashboard_client_id: getDashboardName?.client_id,
    user_id: localStorage.getItem('user_id'),
    start_time: new Date().getTime(),
  };

  const editWidgetHandler = ({ widget_template_id, dashboard_id }) => {
    let urlPath = `/admin/widget/edit/${widget_template_id}?source=dashboard&id=${dashboard_id}`;
    window.open(urlPath, '_blank', 'noopener,noreferrer');
  };

  const checkClickedWidgetButtonURL = widget => {
    let startURL =
      widget?.custom_properties?.buttonInfoUrl?.split('://')?.length ||
      widget?.widget_template?.custom_properties?.buttonInfoUrl?.split('://')
        ?.length;
    if (
      widget?.widget_template?.widget_display_type?.[0] ===
        'external-link-button' &&
      widget?.widget_template?.custom_properties?.buttonWidgetType ==
        'readOnlyWidget'
    ) {
      return false;
    } else if (
      widget?.widget_template?.widget_display_type?.[0] ===
        'external-link-button' &&
      widget?.widget_template?.custom_properties?.buttonWidgetType ==
        'urlWidget'
    ) {
      const buttonURL =
        startURL > 1
          ? widget?.widget_template?.custom_properties?.buttonInfoUrl ||
            widget?.custom_properties?.buttonInfoUrl
          : `http://${widget?.widget_template?.custom_properties?.buttonInfoUrl}` ||
            `http://${widget?.custom_properties?.buttonInfoUrl}`;

      setClickedWidgetButtonURL(buttonURL);
    } else if (
      widget?.widget_template?.widget_display_type?.[0] ===
        'external-link-button' &&
      widget?.widget_template?.custom_properties?.buttonWidgetType ==
        'dashboardWidget'
    ) {
      if (
        widget?.widget_template?.custom_properties?.attachedDashboard
          ?.private &&
        widget?.widget_template?.custom_properties?.attachedDashboard
          ?.owner_user_id !== localStorage.getItem('user_id')
      ) {
        setClickedWidgetButtonURL('/access-denied');
      } else {
        dispatch(
          setPageHeaderComponent({
            activeDashboard: {
              ...widget?.widget_template?.custom_properties?.attachedDashboard,
              id: widget?.widget_template?.custom_properties?.attachedDashboard
                ?.dashboard_id,
              name: widget?.widget_template?.custom_properties
                ?.attachedDashboard?.name,
            },
          })
        );

        setClickedWidgetButtonURL('/dashboard-widget');
      }
    }
  };

  const items = [
    {
      items: [
        {
          label: 'Modify Widget',
          icon: 'pi pi-pencil',
          command: e => {
            e.stopPropagation();
            editWidgetHandler(modifyTemplateId);
          },
          template: item =>
            checkPermission(permissions?.widgetManagement?.editWidget) ? (
              <div
                onClick={item.command}
                className="flex align-items-center gap-2 text-sm text-primary border-round cursor-pointer hover:surface-100"
              >
                <i className={`${item.icon} text-sm`} />
                <span className="white-space-nowrap text-sm">{item.label}</span>
              </div>
            ) : null,
        },
        {
          template: () => <div className="my-1 border-top-1 border-200" />,
        },

        {
          label: 'Remove Widget',
          icon: 'pi pi-times',
          command: e => {
            e.stopPropagation();
            handleDelete();
          },
          template: item =>
            checkPermission(permissions?.widgetManagement?.deleteWidget) ? (
              <div
                onClick={item.command}
                className="flex align-items-center gap-2 text-sm text-red-600 border-round cursor-pointer hover:surface-200"
              >
                <i className={`${item.icon} text-sm`} />
                <span className="white-space-nowrap text-sm">{item.label}</span>
              </div>
            ) : null,
        },
      ],
    },
  ];
  const menuLeft = useRef(null);
  const editClick = () => {
    history.push(`/admin/dashboard/edit/${id}?list=1`);
  };
  const cancelClick = () => {
    history.goBack();
  };

  const buttonArray = [
    {
      label: 'Edit',
      icon: 'pi pi-pencil',
      outlined: false,
      size: 'small',
      action: editClick,
      visible:
        action === 'view' &&
        checkPermission(permissions?.dashboardManagement?.editDashboard),
    },
    {
      label: 'Add Widget',
      icon: 'pi pi-plus',
      outlined: true,
      size: 'small',
      action: handleAddNewWidget,
      visible: action === 'edit' || action === 'create',
    },
    {
      label: 'Save',
      disabled:
        (updatedLayout.length == dashboardData?.length ||
          updatedLayout?.length === 0) &&
        !isWidgetPositionChanged,
      outlined: false,
      size: 'small',
      action: handleSave,
      visible: action === 'edit' || action === 'create',
    },
    {
      label: 'Cancel',
      outlined: false,
      size: 'small',
      action: cancelClick,
      visible: action === 'edit' || action === 'create',
    },
  ];

  return (
    <>
      <Toast ref={toast} />
      {type !== 'home' ? (
        <>
          <PageHeaderBreadcrumb
            headerValue={
              action === 'edit'
                ? 'Edit Dashboard'
                : action === 'view'
                  ? 'View Dashboard'
                  : 'Create Dashboard'
            }
            breadcrumbs={addWidgetBreadcrumb}
            buttonArray={buttonArray}
            identifier="dashboard"
          />
        </>
      ) : null}

      <div className="w-full">
        <DashboardFilters
          title="Apply filter"
          groupedOptions={filterGroupedOptions}
          appliedDimensions={appliedFilterDimensions}
          onAppliedDimensionsChange={setAppliedFilterDimensions}
          onSubmit={handleFilterConfigSubmit}
          loading={filterOptionsLoading}
          submitLoading={filterConfigSubmitLoading}
          disabled={!targetDashboardId}
          type={type}
          filterValues={dashboardFilterValues}
          onFilterValuesChange={setDashboardFilterValues}
          onApply={handleDashboardFiltersApply}
          onClear={handleDashboardFiltersClear}
          hasAppliedCubeFilters={Boolean(dashboardCubeFilters?.length)}
        />
      </div>

      <div style={{ width: '100%', maxWidth: '100%' }}>
        {(loading && widgetQuery?.length === 0) ||
        (loading && action === 'edit') ? (
          <div className="flex gap-2 w-full flex-wrap">
            <Skeleton width="50%" height="10rem" className="border-round-lg" />
            <Skeleton width="27%" height="10rem" className="border-round-lg" />
            <Skeleton width="20%" height="10rem" className="border-round-lg" />
            <Skeleton width="15%" height="10rem" className="border-round-lg" />
            <Skeleton width="82%" height="10rem" className="border-round-lg" />
          </div>
        ) : widgetQuery?.length ? (
          <>
            <ResponsiveGridLayout
              className={`${isDragging ? 'dragging-container' : ''} responsive-grid-layout`}
              layouts={{ lg: layout }}
              cols={{ lg: 12, md: 10, sm: 8, xs: 6, xxs: 4 }}
              onLayoutChange={onLayoutChange}
              containerPadding={[0, 0]}
              rowHeight={25}
              onDrag={() => {
                setIsDragging(true);
                setIsWidgetPositionChanged(true);
              }}
              onDragStop={() => setIsDragging(false)}
              onResizeStart={() => {
                setIsDragging(true);
                setIsWidgetPositionChanged(true);
              }}
              onResizeStop={() => setIsDragging(false)}
              compactType={null}
              preventCollision={true}
              onBreakpointChange={onBreakpointChange}
            >
              {widgetQuery?.length &&
                layout.map(
                  (item, index) => {
                    let startURL =
                      widgetQuery[
                        index
                      ]?.custom_properties?.buttonInfoUrl?.split('://')
                        ?.length ||
                      widgetQuery[
                        index
                      ]?.widget_template?.custom_properties?.buttonInfoUrl?.split(
                        '://'
                      )?.length;

                    return (
                      <div
                        key={widgetQuery[index]?.index?.toString()}
                        className={`${
                          widgetQuery[index]?.chart_type === 'table-report'
                            ? 'table-report-style'
                            : null
                        }`}
                      >
                        <RandomCard
                          index={index}
                          displayType={
                            widgetQuery[index]?.widget_template
                              ?.widget_display_type?.[0]
                          }
                          userColor={
                            widgetQuery[index]?.widget_template
                              ?.custom_properties?.buttonColor
                          }
                          widget={widgetQuery[index]?.widget_template}
                        >
                          <div
                            onContextMenu={e => {
                              e.preventDefault();
                              let onClickArgs = _.cloneDeep(
                                widgetQuery[index]?.widget_template
                              );
                              if (
                                action !== 'edit' &&
                                onClickArgs?.widget_display_type?.[0] !=
                                  'table-report'
                              ) {
                                dispatch(
                                  setPageHeaderComponent({
                                    activeWidget: {
                                      widgetTemplate: onClickArgs,
                                      homeFilters: homeFilters,
                                      dashboardCubeFilters:
                                        dashboardCubeFilters,
                                      dashboardId: targetDashboardId,
                                      region,
                                      storeNumber,
                                      district,
                                      category,
                                      source,
                                      projectType,
                                      installers,
                                      workroom,
                                      status,
                                      homeFilterDateDimension,
                                      scheduleDate,
                                      completionDate,
                                      checkDate,
                                      dateSold,
                                    },
                                  })
                                );
                                setClickedWidgetId(
                                  onClickArgs.widget_template_id
                                );
                                setRoutingWidget(onClickArgs?.route_widget);
                                contextmenuRef.current.show(e);
                              }
                              if (
                                widgetQuery[index]?.widget_template
                                  ?.widget_display_type?.[0] ==
                                'external-link-button'
                              ) {
                                checkClickedWidgetButtonURL(widgetQuery[index]);
                              }
                            }}
                            id={widgetQuery[index]?.widget_id}
                            key={widgetQuery[index]?.index?.toString()}
                            className={`${
                              widgetQuery[index]?.widget_template
                                ?.widget_display_type?.[0] == 'gauge' &&
                              'h-full'
                            } w-full chartClick`}
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              flexWrap: 'wrap',
                              cursor:
                                widgetQuery[index]?.widget_template
                                  ?.widget_display_type?.[0] ===
                                  'external-link-button' &&
                                widgetQuery[index]?.widget_template
                                  ?.custom_properties?.buttonWidgetType ==
                                  'readOnlyWidget'
                                  ? 'none'
                                  : 'pointer',
                            }}
                            onClick={e => {
                              e.preventDefault();
                              const isFromChart =
                                e?.currentTarget?.dataset?.fromChart === 'true';

                              if (action !== 'edit') {
                                if (
                                  ![
                                    'bar-chart',
                                    'pie-chart',
                                    'line-chart',
                                  ].includes(
                                    widgetQuery[index]?.widget_template
                                      ?.widget_display_type?.[0]
                                  ) ||
                                  !isFromChart
                                ) {
                                  dispatch(setChartClickResponse(null));
                                }
                                if (
                                  widgetQuery[index]?.widget_template
                                    ?.widget_display_type?.[0] ===
                                    'external-link-button' &&
                                  widgetQuery[index]?.widget_template
                                    ?.custom_properties?.buttonWidgetType ==
                                    'readOnlyWidget'
                                ) {
                                  return false;
                                } else if (
                                  widgetQuery[index]?.widget_template
                                    ?.widget_display_type?.[0] ===
                                    'external-link-button' &&
                                  widgetQuery[index]?.widget_template
                                    ?.custom_properties?.buttonWidgetType ==
                                    'urlWidget'
                                ) {
                                  if (
                                    widgetQuery[index]?.widget_template
                                      ?.custom_properties?.openIn?.code ==
                                    'new-tab'
                                  ) {
                                    window.open(
                                      startURL > 1
                                        ? widgetQuery[index]?.widget_template
                                            ?.custom_properties
                                            ?.buttonInfoUrl ||
                                            widgetQuery[index]
                                              ?.custom_properties?.buttonInfoUrl
                                        : `http://${widgetQuery[index]?.widget_template?.custom_properties?.buttonInfoUrl}` ||
                                            `http://${widgetQuery[index]?.custom_properties?.buttonInfoUrl}`
                                    );
                                  } else {
                                    window.location.href =
                                      startURL > 1
                                        ? widgetQuery[index]?.widget_template
                                            ?.custom_properties
                                            ?.buttonInfoUrl ||
                                          widgetQuery[index]?.custom_properties
                                            ?.buttonInfoUrl
                                        : `http://${widgetQuery[index]?.widget_template?.custom_properties?.buttonInfoUrl}` ||
                                          `http://${widgetQuery[index]?.custom_properties?.buttonInfoUrl}`;
                                  }
                                } else if (
                                  widgetQuery[index]?.widget_template
                                    ?.widget_display_type?.[0] ===
                                    'external-link-button' &&
                                  widgetQuery[index]?.widget_template
                                    ?.custom_properties?.buttonWidgetType ==
                                    'dashboardWidget'
                                ) {
                                  if (
                                    widgetQuery[index]?.widget_template
                                      ?.custom_properties?.attachedDashboard
                                      ?.private &&
                                    widgetQuery[index]?.widget_template
                                      ?.custom_properties?.attachedDashboard
                                      ?.owner_user_id !==
                                      localStorage.getItem('user_id')
                                  ) {
                                    if (
                                      widgetQuery[index]?.widget_template
                                        ?.custom_properties?.openIn?.code ==
                                      'new-tab'
                                    ) {
                                      window.open('/access-denied', '_blank');
                                    } else {
                                      history.push({
                                        pathname: '/access-denied',
                                      });
                                    }
                                  } else {
                                    dispatch(
                                      setPageHeaderComponent({
                                        activeDashboard: {
                                          ...widgetQuery[index]?.widget_template
                                            ?.custom_properties
                                            ?.attachedDashboard,
                                          id: widgetQuery[index]
                                            ?.widget_template?.custom_properties
                                            ?.attachedDashboard?.dashboard_id,
                                          name: widgetQuery[index]
                                            ?.widget_template?.custom_properties
                                            ?.attachedDashboard?.name,
                                        },
                                      })
                                    );
                                    if (
                                      widgetQuery[index]?.widget_template
                                        ?.custom_properties?.openIn?.code ==
                                      'new-tab'
                                    ) {
                                      window.open(
                                        '/dashboard-widget',
                                        '_blank'
                                      );
                                    } else {
                                      history.push({
                                        pathname: 'dashboard-widget',
                                      });
                                    }
                                  }
                                } else {
                                  let onClickArgs = _.cloneDeep(
                                    widgetQuery[index]?.widget_template
                                  );
                                  if (
                                    action !== 'edit' &&
                                    onClickArgs?.widget_display_type?.[0] !=
                                      'table-report'
                                  ) {
                                    dispatch(
                                      setPageHeaderComponent({
                                        activeWidget: {
                                          widgetTemplate: onClickArgs,
                                          homeFilters: homeFilters,
                                          dashboardCubeFilters:
                                            dashboardCubeFilters,
                                          dashboardId: targetDashboardId,
                                          region,
                                          storeNumber,
                                          district,
                                          category,
                                          source,
                                          projectType,
                                          installers,
                                          workroom,
                                          status,
                                          homeFilterDateDimension,
                                          scheduleDate,
                                          completionDate,
                                          checkDate,
                                          dateSold,
                                        },
                                      })
                                    );
                                    if (onClickArgs?.route_widget) {
                                      if (
                                        (widgetQuery[index]?.widget_template
                                          ?.widget_display_type?.[0] ===
                                          'external-link-button' ||
                                          widgetQuery[index]?.widget_template
                                            ?.widget_display_type?.[0] ===
                                            'card') &&
                                        widgetQuery[index]?.widget_template
                                          ?.custom_properties?.openIn?.code ==
                                          'new-tab'
                                      ) {
                                        window.open('/routing', '_blank');
                                      } else {
                                        history.push({
                                          pathname: 'routing',
                                        });
                                      }
                                    } else {
                                      const widgetId =
                                        onClickArgs.widget_template_id;

                                      if (
                                        (widgetQuery[index]?.widget_template
                                          ?.widget_display_type?.[0] ===
                                          'external-link-button' ||
                                          widgetQuery[index]?.widget_template
                                            ?.widget_display_type?.[0] ===
                                            'card') &&
                                        widgetQuery[index]?.widget_template
                                          ?.custom_properties?.openIn?.code ==
                                          'new-tab'
                                      ) {
                                        const url = `/widget/details/${widgetId}`;
                                        window.open(url, '_blank');
                                      } else {
                                        const url = `/widget/details/${widgetId}`;
                                        history.push({
                                          pathname: url,
                                        });
                                      }
                                    }
                                  }
                                }
                              }
                            }}
                          >
                            <div
                              className={`
                                ${
                                  widgetQuery[index]?.widget_template
                                    ?.widget_display_type?.[0] ===
                                  'external-link-button'
                                    ? 'h-full align-items-center justify-content-center'
                                    : widgetQuery[index]?.chart_type ===
                                        'table-report'
                                      ? 'h-3rem pt-2'
                                      : null
                                } flex justify-content-between align-items-center w-full`}
                            >
                              <div
                                className={`${
                                  widgetQuery[index]?.widget_template
                                    ?.widget_display_type?.[0] ===
                                  'external-link-button' +
                                    widgetQuery[index]?.widget_template
                                      ?.widget_id
                                    ? 'flex justify-content-center'
                                    : widgetQuery[index]?.widget_template
                                        ?.widget_id
                                } col-8 grid-nogutter p-0`}
                              >
                                <Tooltip target={`.widget-title-${index}`} />
                                <div
                                  className={`widget-title-${index} overflow-hidden white-space-nowrap  font-bold text-overflow-ellipsis text-xs`}
                                  style={{
                                    color: widgetQuery[index]?.widget_template
                                      ?.custom_properties?.buttonTextColor
                                      ? widgetQuery[index]?.widget_template
                                          ?.custom_properties?.buttonTextColor
                                      : widgetQuery[index]?.widget_template
                                            ?.widget_display_type?.[0] ===
                                          'external-link-button'
                                        ? 'var(--pf-white)'
                                        : 'var(--back-shade-3)',
                                  }}
                                  data-pr-tooltip={
                                    widgetQuery[index]?.widget_template
                                      ?.widget_name
                                  }
                                  data-pr-position="bottom"
                                >
                                  {
                                    widgetQuery[index]?.widget_template
                                      ?.widget_name
                                  }
                                </div>
                              </div>
                              {action !== 'view' && (
                                <div
                                  className={`flex justify-content-end align-items-center ${
                                    widgetQuery[index]?.chart_type ===
                                    'table-report'
                                      ? 'pb-5'
                                      : ''
                                  }`}
                                >
                                  {checkPermission(
                                    permissions?.widgetManagement?.editWidget
                                  ) &&
                                  checkPermission(
                                    permissions?.widgetManagement?.deleteWidget
                                  ) ? (
                                    <>
                                      <i
                                        onClick={e => {
                                          e.stopPropagation();
                                          e.preventDefault();
                                          menuLeft.current.toggle(e);
                                          handleClick(
                                            e,
                                            widgetQuery[index],
                                            index
                                          );
                                        }}
                                        className="pi pi-ellipsis-v cursor-pointer z-2 text-xs"
                                      />
                                      <Menu
                                        model={items}
                                        popup
                                        ref={menuLeft}
                                        id="popup_menu_left"
                                        className="shadow-none"
                                        pt={{
                                          root: {
                                            className:
                                              'px-2 w-10rem border-300 border-1',
                                          },
                                          submenuHeader: {
                                            className: 'hidden',
                                          },
                                        }}
                                        popupAlignment="right"
                                      ></Menu>
                                    </>
                                  ) : null}
                                </div>
                              )}
                            </div>
                            {widgetQuery[index] &&
                            (widgetQuery[index]?.chart_type !==
                              'external-link-button' ||
                              widgetQuery[index]?.widget_template
                                ?.widget_display_type?.[0] !==
                                'external-link-button') ? (
                              <DashboardWidgetRenderer
                                item={item}
                                widgetDetails={widgetQuery[index]}
                                filterDetails={filterDetails}
                                homeFilters={homeFilters}
                                dashboardCubeFilters={dashboardCubeFilters}
                                applyFilters={applyFilters}
                                setApplyFilters={setApplyFilters}
                                clearFilters={clearFilters}
                                homeFilterDateDimension={
                                  homeFilterDateDimension
                                }
                                type={type}
                                onClickHandler={() => {
                                  if (
                                    type == 'home' &&
                                    ['tabular-report'].includes(
                                      widgetQuery[index]?.chart_type
                                    )
                                  ) {
                                    if (
                                      widgetQuery[index].widget_template
                                        .custom_properties.openIn.code ==
                                      'new-tab'
                                    ) {
                                      let onClickArgs = _.cloneDeep(
                                        widgetQuery[index]?.widget_template
                                      );
                                      const widgetId =
                                        onClickArgs.widget_template_id;
                                      dispatch(
                                        setPageHeaderComponent({
                                          activeWidget: {
                                            widgetTemplate: onClickArgs,
                                            homeFilters: homeFilters,
                                            dashboardCubeFilters:
                                              dashboardCubeFilters,
                                            dashboardId: targetDashboardId,
                                            region,
                                            storeNumber,
                                            district,
                                            category,
                                            source,
                                            projectType,
                                            installers,
                                          },
                                        })
                                      );
                                      if (onClickArgs?.route_widget) {
                                        history.push({
                                          pathname: 'routing',
                                          state: {
                                            widgetTemplate: onClickArgs,
                                            homeFilters: homeFilters,
                                            dashboardCubeFilters:
                                              dashboardCubeFilters,
                                            dashboardId: targetDashboardId,
                                            region,
                                            storeNumber,
                                            district,
                                            category,
                                            source,
                                            projectType,
                                            installers,
                                          },
                                        });
                                      } else {
                                        const url = `/widget/details/${widgetId}`;
                                        history.push({
                                          pathname: url,
                                          state: {
                                            widgetTemplate: onClickArgs,
                                            homeFilters: homeFilters,
                                            dashboardCubeFilters:
                                              dashboardCubeFilters,
                                            dashboardId: targetDashboardId,
                                            region,
                                            storeNumber,
                                            district,
                                            category,
                                            source,
                                            projectType,
                                            installers,
                                          },
                                        });
                                      }
                                    }
                                  }
                                }}
                                dashboardDetails={dashboardDetails}
                              />
                            ) : null}
                          </div>
                        </RandomCard>
                      </div>
                    );
                  }
                  // )
                )}
            </ResponsiveGridLayout>
          </>
        ) : (
          !loading &&
          widgetQuery?.length === 0 && (
            <div className="w-full justify-content-center flex align-items-center flex-column">
              <div
                className="flex align-items-center justify-content-center border-circle bg-blue-100"
                style={{
                  width: '3.5rem',
                  height: '3.5rem',

                  boxShadow: '0 2px 6px rgba(15, 23, 42, 0.12)',
                }}
              >
                <i className="pi pi-inbox text-xl text-primary" />
              </div>
              <span className="text-lg mt-3">No Widgets to display.</span>
              {type === 'home' ? (
                <>
                  <span className="text-xs mt-2 text-600">
                    This dashboard does not have any widgets configured yet.
                  </span>
                  <span className="mt-4 text-sm text-600">
                    Need help? Contact your admin or our support team.
                  </span>
                </>
              ) : (
                <span className="mt-4 text-sm text-600">
                  To save this dashboard, please add at least one widget.
                </span>
              )}
            </div>
          )
        )}

        <AddWidgetsToDashboard
          setDialogOpen={setDialogOpen}
          dialogOpen={dialogOpen}
          setWidgetQuery={setWidgetQuery}
          widgetQuery={widgetQuery}
          dashboardId={id}
        />

        <ConfirmDialog />
      </div>

      <ContextMenu
        model={[
          {
            label: 'Open in new tab',
            icon: 'pi pi-external-link',
            command: () => {
              if (routingWidget) {
                window.open('/routing', '_blank');
              } else if (clickedWidgetButtonURL !== null) {
                window.open(clickedWidgetButtonURL, '_blank');
              } else {
                const url = `/widget/details/${clickedWidgetId}`;
                window.open(url, '_blank', 'noopener,noreferrer');
              }
            },
          },
        ]}
        ref={contextmenuRef}
        breakpoint="767px"
      />
      <Toast ref={toastTopCenter} position="top-center" />
    </>
  );
};

export default AddViewEditDashboard;
